import { useState } from 'react';
import { Reclamo, SourceRead } from '../../../../../api/apiTypes';
import { ConfirmValidationDialog } from '../../../../../utils/dialog/ConfirmValidationDialog';
import Swal from 'sweetalert2';
import SourcesAccordion from '../../../../../components/report/SourcesAccordion';
import { updateReclami, validaReclamo } from '../../../../../api/functionApi';
import { useAxiosInterceptor } from '../../../../../api/wrappers';
import { showDialogConfermaModifica } from '../../../../../utils/dialog/showDialogFunction';
import { formatTitle } from '../../../../../utils/Format';
import ElementGenerationsPanel from '../../../ElementGenerationsPanel';
import EventList from '../../../../../utils/EventList';

type ContainerListaDriverPageProps = {
  intermediario: Reclamo;
  title: string;
  id: string;
  driverId: string;
  intermediarioId: string;
  sources: SourceRead[];
  events: any[];
};

const ContainerReclamiDettaglio = ({
  intermediario,
  title,
  id,
  driverId,
  intermediarioId,
  sources,
  events
}: ContainerListaDriverPageProps) => {

  useAxiosInterceptor();

  const formattedTitle = formatTitle(title);

  const [values, setValues] = useState({
    total_claims: intermediario.value.total_claims,
    investment_services_claims: intermediario.value.investment_services_claims,
    source_fiscal_year: intermediario.value.source_fiscal_year,
  });

  const [isEditing, setIsEditing] = useState(false);
  const [showDialogConfermaValidazione, setShowDialogConfermaValidazione] = useState(false);
  const [isIntermediarioValidato, setIsIntermediarioValidato] = useState(intermediario.validation === "validated");


  if (!intermediario) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-20 h-20 border-[6px] border-gray-300 border-t-textPrimary rounded-full animate-spin" />
      </div>
    );
  }

  // Mappa per i titoli degli input
  const inputTitles: { [key: string]: string } = {
    total_claims: "Reclami totali",
    investment_services_claims: "Reclami investimento",
    percentage_investment_claims: "Percentuali",
      source_fiscal_year: "Anno fiscale", // aggiunto titolo per il nuovo campo
  };

  const handleModifica = () => {
    showDialogConfermaModifica(
      () => {
        setIsEditing(true);
      },
    );
  };

  const handleAnnulla = () => {
    setValues({
      total_claims: intermediario.value.total_claims,
      investment_services_claims: intermediario.value.investment_services_claims,
    source_fiscal_year: intermediario.value.source_fiscal_year,
    });
    setIsEditing(false);
  };

  const handleSalva = async () => {
    const payload = {
      value: values,
    };

    try {
      await updateReclami(id, driverId, intermediarioId, payload);
      setIsEditing(false);
    setIsIntermediarioValidato(false);

      Swal.fire({
        icon: 'success',
        title: 'Modifica salvata!',
        text: 'Le modifiche sono state salvate correttamente.',
        confirmButtonColor: '#374151',
      });

    } catch (error) {
      console.error('Errore durante il salvataggio:', error);

      Swal.fire({
        icon: 'error',
        title: 'Errore nel salvataggio',
        text: 'Si è verificato un errore durante il salvataggio delle modifiche.',
        confirmButtonColor: '#374151',
      });
    }
  };


  const onClickValida = () => setShowDialogConfermaValidazione(true);

const handleValidazione = async () => {
  setShowDialogConfermaValidazione(false);

  // Mostra Swal di caricamento
  Swal.fire({
    title: 'Validazione in corso...',
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });

  try {
    await validaReclamo(id, driverId, intermediarioId);
    setIsIntermediarioValidato(true);

    Swal.fire({
      icon: 'success',
      title: 'Validato!',
      text: 'L\'intermediario è stato validato con successo.',
      confirmButtonColor: '#374151',
    });
  } catch (error) {
    console.error('Errore durante la validazione:', error);

    Swal.fire({
      icon: 'error',
      title: 'Errore nella validazione',
      text: 'Si è verificato un errore durante la validazione dell\'intermediario.',
      confirmButtonColor: '#374151',
    });
  }
};

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-8">
      <h1 className="text-4xl font-bold text-[#1B365D] mb-8">{formattedTitle}</h1>
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-[#1B365D]">{intermediario.name}</h1>
        <span className="font-medium text-gray-600 text-sm">Score: {intermediario.value.score.total_score}</span>
      </div>
<div className="flex flex-col md:flex-row md:space-x-8 mb-8">
  {Object.entries(values)
    .filter(([key]) => key !== 'score')
    .map(([key, val]) => (
      <div key={key} className="w-full mb-4 md:mb-0">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          {inputTitles[key]}
        </label>
        <div className="relative">
          <input
            type="number"
            value={val as number}
            readOnly={!isEditing}
            onChange={(e) => {
              if (isEditing) {
                setValues((prev) => ({
                  ...prev,
                  [key]: Number(e.target.value),
                }));
              }
            }}
            className={`mt-1 block w-full rounded-md border border-gray-300 focus:border-[#1B365D] focus:ring focus:ring-[#1B365D]/20 p-2 ${
              isEditing ? 'bg-white' : 'bg-gray-100'
            }`}
          />
          {key === 'percentage_investment_claims' && (
            <span className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5">
              %
            </span>
          )}
        </div>
      </div>
    ))}
</div>
      {!['approved', 'drafted', 'completed'].includes(intermediario.report_status ?? '') && (
      <div className="flex justify-end space-x-4">
        {!isEditing ? (
        (
            <>
              <button
                onClick={handleModifica}
                className="px-4 py-2 bg-[#1B365D] text-white hover:bg-[#142a4a] rounded-lg"
              >
                Modifica
              </button>
              <button
                onClick={onClickValida}
  disabled={isIntermediarioValidato}
                   className={`px-4 py-2 rounded 
            ${isIntermediarioValidato 
              ? 'bg-gray-200 text-gray-400 cursor-not-allowed' 
              : 'bg-textPrimary text-white hover:bg-textSecondary'}`
          }              >
                Valida
              </button>
            </>
          )
        ) : (
          <>
            <button
              onClick={handleAnnulla}
              className="px-4 py-2 bg-gray-200 text-gray-800 hover:bg-gray-300 rounded"
            >
              Annulla
            </button>
            <button
              onClick={handleSalva}
              className="px-4 py-2 bg-[#1B365D] text-white hover:bg-[#142a4a] rounded-lg"
            >
              Salva
            </button>
          </>
        )}
  
        {showDialogConfermaValidazione && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
            <div className="bg-white p-6 rounded shadow-lg max-w-sm w-full">
              <ConfirmValidationDialog
                onConferma={handleValidazione}
                onAnnulla={() => setShowDialogConfermaValidazione(false)}
              />
            </div>
          </div>
        )}
      </div>
      )}
      <SourcesAccordion sources={sources} reportId={id} componentId={driverId} elementId={intermediarioId} />

                {/* Sezione Attività */}
<EventList events={events} />
      <ElementGenerationsPanel reportId={id} componentId={driverId} elementId={intermediarioId} />
    </div>
  );
};

export default ContainerReclamiDettaglio;